module.exports = __webpack_public_path__ + "img/barra-naranja.b19bea67.svg";